import React from 'react';
import classes from "./SubscribePage.module.css";
import { useNavigate, useSearchParams } from 'react-router-dom';
import { FaChevronRight, FaCopyright } from 'react-icons/fa6';
import { useState } from 'react';
import { useEffect } from 'react';
import { v4 as uuidv4 } from "uuid";
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { SendOtpAPI } from '../api/api';
import { useAppSelector } from '../Store/hooks';
import BackgroundLayout from '../Components/BackgroundLayout';
import { motion, useAnimationControls } from "framer-motion";
import { InputText } from 'primereact/inputtext';
import Spinner from '../Components/Loaders/Spinner';

const SubscribePage = () => {

    const navigate = useNavigate();
    const [msisdn, setMsisdn] = useState("");
    const [loading, setLoading] = useState(false);
    const [termsModal, setTermsModal] = useState(false);
    const [extRef, setExtRef] = useState(null);
    const [searchParams, setSearchParams] = useSearchParams() as any;

    const { user } = useAppSelector(state => state.userSlice);

    const variants = {
        hidden: {
            opacity: 0,
            scale: 0,
        },
        visible: {
            opacity: 1,
            scale: 1,
        },
    };

    const controls = useAnimationControls();

    useEffect(() => {
        controls.start("visible");
    }, []);

    useEffect(() => {
        if (user) {
            navigate("/home");
        }
    }, [user]);

    useEffect(() => {
        if (searchParams.get("ext_ref")) {
            setExtRef(searchParams.get("ext_ref"));
        } else {
            setSearchParams({ ext_ref: uuidv4() });
        }
    }, [searchParams]);

    const handleFormSubmission = async (e: any) => {
        e.preventDefault();

        try {
            if (msisdn?.trim().length == 0) {
                return;
            }
            setLoading(true);

            let msisdnWithCountryCode = msisdn?.toString().trim().replace(/\D/g, '');

            if (msisdnWithCountryCode.startsWith('0')) {
                msisdnWithCountryCode = msisdnWithCountryCode.slice(1);
            }

            if (!msisdnWithCountryCode.startsWith('94')) {
                msisdnWithCountryCode = '94' + msisdnWithCountryCode;
            }

            const response = await SendOtpAPI(msisdnWithCountryCode);
            console.log(response, 'response');
            setLoading(false);
            navigate("/otp", {
                state: {
                    msisdn: msisdnWithCountryCode,
                    referenceNo: response?.data?.data?.referenceNo,
                    extRef: extRef
                }
            })

        } catch (error: any) {
            setLoading(false);
            toast.error(error?.response?.data?.message || error?.response?.message || error?.data?.message || "Something Went Wrong!");
        }
    }


    return (
        <BackgroundLayout style={{padding:0}}>
            <motion.div
                layout
                variants={variants}
                initial="hidden"
                animate={controls}
                transition={{
                    type: "spring",
                    stiffness: 700,
                    damping: 30,
                }}
                className={classes.auth_modal}
            >
                <div className={classes.auth_sub_modal}>
                    <motion.div className={classes.form_modal}>
                        <img src="/assets/images/logo2.png" alt="uvmovie" className={classes.logo} />
                        {/* <p className={classes.title}>Subscribe Service</p> */}

                        <form className={classes.form} onSubmit={handleFormSubmission}>
                            <InputText
                                required
                                type="number"
                                className={`p-inputtext-lg ${classes.input}`}
                                placeholder="Sri Lankan Mobile Number"
                                value={msisdn}
                                onChange={(e) => setMsisdn(e.target.value)}
                            />

                            <div className={classes.packs}>

                                <button type='button' className={`${classes.pack_box} ${classes.shade_blue}`}
                                >
                                    <span className={`${classes.pack_header} ${classes.shade_blue}`}>Prepaid subscription price point</span>
                                    <p className={`${classes.pack_price_point} ${classes.active}`}>
                                        10 LKR{" "}/{" "}
                                        Day
                                    </p>
                                </button>

                                <button type='button' className={`${classes.pack_box} ${classes.shade_green}`}

                                >
                                    <span className={`${classes.pack_header} ${classes.shade_green}`}>Postpaid subscription price point</span>
                                    <p className={`${classes.pack_price_point} ${classes.active}`}>
                                        300 LKR{" "}/{" "}
                                        Month
                                    </p>
                                </button>

                            </div>


                            <button
                                type="submit"
                                disabled={loading}
                                className={classes.signup_btn}
                            >
                                {loading ? (
                                    <div
                                        style={{
                                            width: "100%",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                        }}
                                    >
                                        <Spinner />
                                    </div>
                                ) : (
                                    "Subscribe"
                                )}
                            </button>

                            <div className={classes.grid_container}>
                                <span className={classes.grid_item}></span>
                                <span className={classes.or}>Or</span>
                                <span className={classes.grid_item}></span>
                            </div>

                            <p className={classes.link_text}>
                                Already a Subscriber!{" "}
                                <span
                                    className={classes.link}
                                    onClick={() => {
                                        navigate(`/login?ext_ref=${extRef}`)  
                                    }}
                                >
                                   Login
                                </span>
                            </p>

                        </form>
                    </motion.div>
                    <div className={classes.benefits_modal}>
                        <p className={classes.benefits_title}>Benefits of Service</p>

                        <div className={classes.benefits}>
                            <div className={classes.benefit}>
                                <div className={classes.benefit_title}>
                                    <i className={`pi pi-circle-fill ${classes.icon}`} />
                                    <p className={classes.bt}>Large Community</p>
                                </div>
                                <p className={classes.bd}>
                                    Interact with the large community and know what is trending.
                                </p>
                            </div>

                            <div className={classes.benefit}>
                                <div className={classes.benefit_title}>
                                    <i className={`pi pi-circle-fill ${classes.icon}`} />
                                    <p className={classes.bt}>Watch Shortz</p>
                                </div>
                                <p className={classes.bd}>
                                    Watch the shortz (clips) of movies and series.
                                </p>
                            </div>

                            <div className={classes.benefit}>
                                <div className={classes.benefit_title}>
                                    <i className={`pi pi-circle-fill ${classes.icon}`} />
                                    <p className={classes.bt}>Your watchlist</p>
                                </div>
                                <p className={classes.bd}>
                                    Create your personalised watchlist of movies.
                                </p>
                            </div>

                            <div className={classes.benefit}>
                                <div className={classes.benefit_title}>
                                    <i className={`pi pi-circle-fill ${classes.icon}`} />
                                    <p className={classes.bt}>Ratings</p>
                                </div>
                                <p className={classes.bd}>
                                    Rate and remember eveything you've seen.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </motion.div>

        </BackgroundLayout>
    )
}

export default SubscribePage